import {
  ACCESS_TOKEN_NAME,
  JSON_CONTENT_TYPE,
} from '../../_constant/constants';
import { TaskDeleteTaskDto } from '../../_dto/_task/TaskDeleteTaskDto';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiDeleteTask = async (taskDeleteTaskDto: TaskDeleteTaskDto) => {
  const params: IApiParams = {
    url: '/task/deleteTask.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'DELETE', taskDeleteTaskDto);
};
